import { MantineReactTable } from "mantine-react-table";

const Table = ({ columns, data, ...props }) => {
  return <MantineReactTable columns={columns} data={data} {...props} />;
};

export default Table;
